import memoize from 'memoize-one';
export const getUserVirtualMachines = memoize((store) => {
    return store.get('vNextUserVirtualMachineStore').get('virtualMachines');
});
